import React from 'react';
import { useTranslation } from 'react-i18next';

// Icons
import { IoClose } from "react-icons/io5";

// Components
import CustomButton from '../../../components/CustomButton';
import Typography from '../../../components/Typography';

// Styles
import styles from './style.module.scss';

// Context
import { useGenerateModalContext } from '../context';

// Assets
import VideoPng from 'images/icons/video.png'
import PodcastPng from 'images/icons/podcast.png'
import HelpTooltip from '../../../components/HelpTooltip';

interface GenerateModalHeaderProps {
  onClose: () => void;
}

const GenerateModalHeader: React.FC<GenerateModalHeaderProps> = ({ onClose }) => {
  // Hooks
  const { t } = useTranslation();

  // Context
  const { type } = useGenerateModalContext();


  let title = '';
  let icon = null;
  switch (type) {
    case 'video':
      title = t('generate.video.title');
      icon = VideoPng;
      break;
    case 'podcast':
      title = t('generate.podcast.title');
      icon = PodcastPng;
      break;
  }

  // Hooks
  return (
    <div className={styles.header}>
      <div className={styles.icon_container}>
        {icon && <img src={icon} alt={title} className={styles.icon} />}
      </div>
      <div className='flex items-center gap-2'>
        <span>{title}</span>
        <HelpTooltip type={type === 'video' ? 'video' : 'podcast'} />
      </div>

      <CustomButton classes={{ root: styles.closeButton }} variant='text' onClick={onClose}>
        <IoClose />
      </CustomButton>
    </div>
  );
};

export default GenerateModalHeader;
